export const consumer = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
      consumer_name:'Consumer Name',
      consumer_management:'Consumer Management',
      consumer_id:'Consumer ID',
      consumer_no:'Consumer No',
      device_ui:'Device UI',
      door_no:'Door No',
      flat_no:'Flat No',
      tower_name:'Tower Name',
      location:'Location',
      city:'City',
      status:'Status',
      date_and_time:'Date & Time',

    },

    ar: {
      consumer_name:'اسم المستهلك',
      consumer_management:'إدارة المستهلك',
      consumer_id:'معرف المستهلك',
      consumer_no:'رقم المستهلك',
      device_ui:'واجهة مستخدم الجهاز',
      door_no:'رقم الباب',
      flat_no:'رقم الشقة',
      tower_name:'اسم البرج',
      location:'الموقع',
      city:'المدينة',
      status:'الحالة',
      date_and_time:'التاريخ والوقت',

    },
}